//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ItemCard from "~/components/gallery/ItemCard";
import MasterpieceSelectBottom from "~/components/profile/MasterpieceSelectBottom";
import MasterpieceSelectItem from "~/components/profile/MasterpieceSelectItem";
import Button from "~/components/other/Button";
import MtModal from '~/components/Modal/MtModal'
import { debounce, formatDate, declOfNum } from '~/utils/utils';
const imagesLoaded = require('imagesloaded');
import { Portal } from 'portal-vue'
import Hint from '@/components/other/Hint'

export default {
  components: {
    Hint,
    ItemCard,
    MasterpieceSelectBottom,
    MasterpieceSelectItem,
    Button,
    MtModal,
    Portal
  },
  props: {
    totalSum: {
      type: [String, Number],
      default: 0
    },
    selectCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      selectedItems: [],
      canSelect: this.selectCount > 0,
      countArr: [],
      opened: false,
      pictures: [],
      showDelete: false,
      selected: {},
      modal: null,
      openModal: false,
      hint: false
    }
  },
  computed:{
    getParams() {
      const date = formatDate(new Date(), 'MM.YYYY', -1).split('.')
      return {
        month: date[0],
        year: date[1]
      }
    },
    getCurrentPictures() {
      return this.pictures.filter(elem => !elem.inCurrentUserMirGallery)
    },
    selectedPictures() {
      return [...this.selectedItems]
    },
    getMounth() {
      return formatDate(new Date(), 'MMMM')
    },
    getPrevMounth() {
      return formatDate(new Date(), 'MMMM', -1)
    }
  },
  methods: {
    getDeclination(num, key){
      if (this.$i18n.locale === 'en') {
        return this.$tc(key, num > 1 ? 2 : 1)
      } else {
        return this.$tc(key, declOfNum(num));
      }
    },
    openHint() {
      this.hint = {
        message: this.$t('masterpieceSelect.hint1') + this.getPrevMounth + this.$t('masterpieceSelect.hint2'),
        buttonText: this.$t('masterpieceSelect.hintButtonText'),
      }
    },
    createListener() {
      this.pictures.forEach((item) => {
        item.selected = false
      })
      this.countArr = new Array(this.selectCount)
      this.resizeAllGridItems();
      window.addEventListener("resize", this.resizeAllGridItems);

      let allItems = document.getElementsByClassName("picture-card");
      for (let x = 0; x < allItems.length; x++) {
        imagesLoaded( allItems[x], this.resizeInstance);
      }
    },
    currentNumber(num) {
      if (!num) {
        return '0 ₽'
      }
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ') + ' ₽'
    },
    checkSelectedItems(){
      this.canSelect = this.selectedItems.length < this.selectCount
    },
    toggleSelectItem(){
      this.selectedItems = this.pictures.filter((item) => {
        return item.selected
      })
      this.opened = this.selectedItems.length >= this.selectCount
      this.checkSelectedItems()
      this.selectedItems = this.selectedPictures
    },
    checkForDelete(item){
      this.selectedItems.forEach((selectedItem) => {
        item.id === selectedItem.id ? selectedItem.delete = item.delete: null
      })
      this.checkButtons()
    },
    checkButtons(){
      let checkedForDelete = this.selectedItems.filter((item) => {
        return item.delete
      })
      checkedForDelete.length > 0 ? this.showDelete = true : this.showDelete = false
      this.selectedItems = this.selectedPictures
    },
    deleteChecked(){
      this.selectedItems = this.selectedItems.filter((selectedItem, i) => {
        let deletedItem
        this.pictures.forEach((item) => {
          if (item.id === selectedItem.id){
            if (selectedItem.delete) {
              item.selected = false
              deletedItem = selectedItem
            }
            selectedItem.delete = false
          }
        })
        return !deletedItem
      })
      this.checkSelectedItems()
      this.checkButtons()
    },
    uncheckForDelete(){
      this.selectedItems.forEach((item) =>{
        item.delete = false
      })
      this.selectedItems = this.selectedPictures
      this.checkButtons()
    },
    resizeGridItem(item) {
      const grid = document.querySelector(".masterpiece-select-list");
      if (!grid) return
      const rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
      // const rowSpan = Math.ceil((item.querySelector('.picture-content').getBoundingClientRect().height+rowGap)/(rowHeight+rowGap));
      const rowSpan = Math.ceil(item.querySelector('.picture-content').offsetHeight / rowHeight);
      item.style.gridRowEnd = `span ${rowSpan}`;
    },
    closeMasterpiece(){
      this.$emit('close')
    },

    resizeAllGridItems: debounce(function() {
      let allItems = document.getElementsByClassName("picture-card");
      for (let x = 0; x < allItems.length; x++) {
        this.resizeGridItem(allItems[x]);
        imagesLoaded( allItems[x], this.resizeInstance);
      }
    }, 50),

    resizeInstance(instance) {
      const item = instance.elements[0];
      this.resizeGridItem(item);
    },

    addToMyCollection() {
      const selectedImages = []
      this.pictures.forEach(item => {
        if(item.selected) {
          selectedImages.push(item.id)
        }
      })

      if (selectedImages.length) {
        let result = true
        let data = ''
        selectedImages.forEach(elem => {
          if (data) {
            data += '&'
          }
          data += `itemId[]=${elem}`
        })
        this.$axios({
          method: 'post',
          url: '/api/v1/user/addMasterpieceLoyalty',
          data
        })
          .then(({data}) => {
            if (data.error) {
              this.modal = {
                title: this.$t('masterpieceSelect.errorModalTitle'),
                message: data.error.message,
                buttonText: this.$t('masterpieceSelect.errorModalButtonText'),
              }
            } else {
              // window.location.href = 'profile/gallery#mir'
              this.$router.push('/profile/gallery#mir')
              setTimeout(() => this.$emit('close'), 500)
            }
          })
          .catch(err => {
            console.log('ERORRRR', err)
          })
      }
    }
  },
  chimera: {
    getGallery () {
      return {
        url: `/api/v1/gallery/getLoyaltyOpenGallery`,
        key: 'masterpiece-for-mir-items',
        auto: true,
        params: {
          ...this.getParams,
          lang: this.$i18n.locale || 'ru'
        },
        on: {
          success () {
            this.pictures = this.getGallery.data.data || []
            this.createListener()
          }
        }
      }
    }
  }
}
